import { useQuery } from "@tanstack/react-query";
import { fetchClient } from "../../API/fetchClient";
import type { BusinessUnit } from "../../types/entities";

export const useGetBUs = () =>
  useQuery({
    queryKey: ["bus"],
    queryFn: async (): Promise<BusinessUnit[]> => {
      const resp = await fetchClient<BusinessUnit[]>("/iam/bu/");
      if (resp.error || !resp.data) throw resp.error || new Error("Failed to fetch BUs");
      return resp.data;
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

export default useGetBUs;
